import {createAction} from '@reduxjs/toolkit';

import {CurrentStoreType} from 'store/types/app';
import {MembershipCard, StoreArea, VerifyVoucherResponse} from 'types';

import {AppMode} from '../../constants';

export const fetchMakroMembershipCardAction = createAction<string>('FETCH_MAKRO_MEMBERSHIP_CARD');

export const setMembershipCardsAction = createAction<MembershipCard[]>('SET_MEMBERSHIP_CARDS');

export const setDefaultMembershipCardAction = createAction<MembershipCard | undefined>('SET_DEFAULT_MEMBERSHIP_CARD');

export const applyVoucherAction = createAction<string>('APPLY_VOUCHER');
export const setVoucherDataAction = createAction<VerifyVoucherResponse | undefined>('SET_VOUCHER_DATA');
export const removeVoucherAction = createAction<string>('REMOVE_VOUCHER');

export const setCurrentStoreAction = createAction<CurrentStoreType | undefined>('SET_CURRENT_STORE');

export const setCurrentStoreWithLocationLocalesAction = createAction<CurrentStoreType>(
  'SET_CURRENT_STORE_WITH_LOCATION_LOCALES'
);

export const getStoreAreasAction = createAction('GET_CURRENT_STORE_AREAS');

export const setStoreAreasAction = createAction<StoreArea[]>('SET_STORE_AREAS_ACTION');

export const setIsDirectCheckoutAction = createAction<boolean>('SET_IS_DIRECT_CHECKOUT');
export const setAccessTradeClickIdAction = createAction<string | undefined>('SET_ACCESSTRADE_CLICK_ID');
export const setTrueIdAction = createAction<string | undefined>('SET_TRUE_ID');
export const setMpidAction = createAction<string | undefined>('SET_MPID');
export const setPricezaClickIdAction = createAction<string | undefined>('SET_PRICEZA_CLICK_ID');

export const setIsAppLoadingAction = createAction<boolean>('SET_IS_APP_LOADING');

export const setAppModeAction = createAction<AppMode>('SET_APP_MODE');
export const setAppVersionAction = createAction<string>('SET_APP_VERSION');
export const setDeviceOSAction = createAction<string>('SET_DEVICE_OS');

export const resetStateAction = createAction('RESET_STATE');

export const setCarouselMaxItemsCount = createAction<string>('SET_CAROUSEL_MAX_ITEMS_COUNT');

export const setOmniChannelsVoucherRedemptionEnabled = createAction<boolean>(
  'SET_OMNI_CHANNELS_VOUCHER_REDEMPTION_ENABLED'
);

export const setIsFromBasketNotification = createAction<boolean>('SET_IS_FROM_BASKET_NOTIFICATION');
export const setShowBuildInfo = createAction<boolean>('SET_BASKET_INFO');
export const setNeedRetriggerCheckoutAction = createAction<boolean>('SET_NEED_RETRIGGER_CHECKOUT');
export const setIsStoreInactiveAction = createAction<boolean>('SET_IS_STORE_INACTIVE');
